import { apiJson, saveSession, clearSession, getToken } from "@/services/api";

const state = {
  usuarios: [],
  roles: [],
  usuarioActual: null,
};

const getters = {
  getUsuarioActual: (s) => s.usuarioActual,
  getUsuarios: (s) => s.usuarios,
};

const mutations = {
  setUsuarioActual(state, usuario) {
    state.usuarioActual = usuario;
  },
  setUsuarios(state, usuarios) {
    state.usuarios = usuarios;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
};

const actions = {
  async iniciarSesion({ commit }, { correo, contraseña }) {
    const res = await apiJson("POST", "/auth/login", { correo, contraseña });
    const { token, usuario } = res.data;
    saveSession(token, usuario);
    commit("setUsuarioActual", usuario);
    return usuario;
  },
  /** Registra la salida en el backend (Administra tus dispositivos) y borra la sesión local. */
  async cerrarSesion({ commit }) {
    if (getToken()) {
      await apiJson("POST", "/auth/logout").catch(() => {});
    }
    clearSession();
    commit("setUsuarioActual", null);
  },
  async consultarSesiones() {
    const res = await apiJson("GET", "/auth/sesiones");
    return { sesiones: res.data, dias: res.dias };
  },
  async cerrarSesionDispositivo(_, { id }) {
    const res = await apiJson("DELETE", `/auth/sesiones/${encodeURIComponent(id)}`);
    return res.data;
  },
  async cerrarOtrasSesiones() {
    const res = await apiJson("POST", "/auth/sesiones/cerrar-otras");
    return res.data;
  },
  /** Carga el usuario de la sesión actual (rol, name, etc.) desde el backend y lo guarda en el store */
  async cargarUsuarioActual({ commit }) {
    if (!getToken()) return null;
    try {
      const res = await apiJson("GET", "/auth/me");
      commit("setUsuarioActual", res.data);
      return res.data;
    } catch (e) {
      commit("setUsuarioActual", null);
      return null;
    }
  },
  async consultarRoles({ commit }) {
    const res = await apiJson("GET", "/roles");
    commit("setRoles", res.data);
    return res.data;
  },
  async consultarUsuarios({ commit }) {
    const res = await apiJson("GET", "/usuarios");
    commit("setUsuarios", res.data);
    return res.data;
  },
  async registrarUsuario(_, { correo, contraseña, nombre, rol }) {
    const res = await apiJson("POST", "/usuarios", { correo, contraseña, nombre, rol });
    return res.data;
  },
  async actualizarDatosUsuarioBD(_, { rol, nombre, id, estatus }) {
    await apiJson("PUT", `/usuarios/${encodeURIComponent(id)}`, { nombre, rol, status: estatus });
  },
  /** Asigna una nueva contraseña a otro usuario; el backend cierra todas sus sesiones. */
  async actualizarContrasenaUsuario(_, { id, contraseña }) {
    const res = await apiJson("PUT", `/usuarios/${encodeURIComponent(id)}/contrasena`, { contraseña });
    return res.data;
  },
  /** Eliminación lógica (solo Administrador): lo inactiva y lo mueve a Usuarios eliminados. */
  async eliminarUsuario(_, { id }) {
    const res = await apiJson("DELETE", `/usuarios/${encodeURIComponent(id)}`);
    return res.data;
  },
  /** Solo Administrador: saca al usuario de Usuarios eliminados y lo deja activo. */
  async restaurarUsuario(_, { id }) {
    const res = await apiJson("POST", `/usuarios/${encodeURIComponent(id)}/restaurar`);
    return res.data;
  },
  async consultarUsuariosEliminados() {
    const res = await apiJson("GET", "/usuarios/eliminados");
    return res.data;
  },
  /** Envía al usuario un correo con un enlace para restablecer su contraseña (válido 1 hora). */
  async enviarRestablecimiento(_, { id }) {
    const res = await apiJson("POST", `/usuarios/${encodeURIComponent(id)}/enviar-restablecimiento`);
    return res.data;
  },
  async cambiarContrasena(_, { actual, nueva }) {
    const res = await apiJson("POST", "/auth/cambiar-contrasena", { actual, nueva });
    return res.data;
  },
  /** "¿Olvidaste tu contraseña?": el backend envía el enlace de restablecimiento a ese correo. */
  async solicitarRestablecimiento(_, { correo }) {
    const res = await apiJson("POST", "/auth/solicitar-restablecimiento", { correo });
    return res.data;
  },
  async restablecerContrasena(_, { token, nueva }) {
    const res = await apiJson("POST", "/auth/restablecer-contrasena", { token, nueva });
    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
